/* ATC Upselling — Add-to-Cart Upsell-Popup (Konfiguration: Theme-Settings) */
/* ============================================================
   "Wird oft zusammen gekauft" – Add-to-Cart Upsell-Popup
   Hängt sich an MiniCart.renderContents (einziger Choke-Point
   aller Add-to-Cart-Pfade: Produktseite, Quick-View, Quick-Add).
   Ablauf: Add -> Popup (falls Upsell-Produkte) -> "Weiter" -> Drawer.
   ============================================================ */
(function () {
  'use strict';

  var SECTION = 'fbt-popup';

  var FBT = {
    overlay: null,
    scroll: null,
    onContinue: null,
    pendingHandle: null,
    pendingVariant: null,
    suppressNext: false,

    // Handle des Produkts aus dem absendenden Add-to-Cart-Formular ermitteln
    resolveHandleFromForm: function (form) {
      if (!form) return null;
      var m;
      // 1. <product-info data-url="/products/handle">
      var info = form.closest && form.closest('product-info');
      if (info && info.getAttribute('data-url')) {
        m = info.getAttribute('data-url').match(/\/products\/([^\/?#]+)/);
        if (m) return m[1];
      }
      // 2. Produkt-Link in der umgebenden Karte (Quick-Add / Collection)
      var card = form.closest && form.closest(
        'li, .card-wrapper, .card, .grid__item, quick-add-modal, .quick-add-modal, .product-card'
      );
      var link = card && card.querySelector('a[href*="/products/"]');
      if (link) {
        m = link.getAttribute('href').match(/\/products\/([^\/?#]+)/);
        if (m) return m[1];
      }
      // 3. globales Produkt-Objekt (Produktseite)
      if (window.meta && window.meta.product && window.meta.product.handle) {
        return window.meta.product.handle;
      }
      // 4. aktuelle URL (Produktseite)
      m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
      if (m) return m[1];
      return null;
    },

    cartAddUrl: function () {
      return (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add';
    },

    drawerSections: function () {
      var mc = document.querySelector('mini-cart');
      if (mc && typeof mc.getSectionsToRender === 'function') {
        return mc.getSectionsToRender().map(function (s) { return s.id; });
      }
      return ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
    },

    // Section-HTML aus einer Section-Rendering-Antwort in den DOM schreiben
    applySections: function (sections) {
      if (!sections) return;
      this.drawerSections().forEach(function (id) {
        var el = document.getElementById(id);
        if (el && sections[id]) {
          var doc = new DOMParser().parseFromString(sections[id], 'text/html');
          var inner = doc.querySelector('.shopify-section');
          el.innerHTML = inner ? inner.innerHTML : sections[id];
        }
      });
    },

    buildShell: function () {
      if (this.overlay) return;
      var overlay = document.createElement('div');
      overlay.className = 'fbt-overlay';
      overlay.setAttribute('hidden', '');
      overlay.innerHTML =
        '<div class="fbt-modal" role="dialog" aria-modal="true" aria-label="Wird oft zusammen gekauft">' +
          '<button type="button" class="fbt-close" aria-label="Schließen">&times;</button>' +
          '<div class="fbt-scroll"></div>' +
          '<div class="fbt-foot"><button type="button" class="fbt-continue">Zum Warenkorb</button></div>' +
        '</div>';
      document.body.appendChild(overlay);

      this.overlay = overlay;
      this.scroll = overlay.querySelector('.fbt-scroll');

      var self = this;
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) self.close();
      });
      overlay.querySelector('.fbt-close').addEventListener('click', function () { self.close(); });
      overlay.querySelector('.fbt-continue').addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-open')) self.close();
      });

      // Klick auf "Hinzufügen" (Event-Delegation)
      this.scroll.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-fbt-add]');
        if (btn) self.addItem(btn);
      });

      // Preis bei Variantenwechsel aktualisieren
      this.scroll.addEventListener('change', function (e) {
        var vsel = e.target.closest('.fbt-popup__variant');
        if (!vsel) return;
        var opt = vsel.options[vsel.selectedIndex];
        var item = vsel.closest('[data-fbt-item]');
        var priceEl = item && item.querySelector('.fbt-popup__price-current');
        if (priceEl && opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      });
    },

    open: function (innerHTML, onContinue) {
      this.buildShell();
      this.onContinue = onContinue || null;
      this.scroll.innerHTML = innerHTML;
      this.overlay.removeAttribute('hidden');
      // reflow für Transition
      void this.overlay.offsetWidth;
      this.overlay.classList.add('is-open');
      document.documentElement.classList.add('fbt-lock');
    },

    close: function () {
      if (!this.overlay) return;
      this.overlay.classList.remove('is-open');
      document.documentElement.classList.remove('fbt-lock');
      var self = this;
      setTimeout(function () { if (self.overlay) self.overlay.setAttribute('hidden', ''); }, 220);
      var cont = this.onContinue;
      this.onContinue = null;
      if (typeof cont === 'function') cont();
    },

    addItem: function (btn) {
      if (btn.classList.contains('is-loading') || btn.classList.contains('is-incart')) return;
      var item = btn.closest('[data-fbt-item]');
      var sel = item && item.querySelector('.fbt-popup__variant');
      var variantId = sel ? sel.value : btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.classList.add('is-loading');
      var spinner = btn.querySelector('.fbt-popup__add-spinner');
      if (spinner) spinner.hidden = false;

      var body = new FormData();
      body.append('id', variantId);
      body.append('quantity', 1);
      this.drawerSections().forEach(function (id) { body.append('sections[]', id); });
      body.append('sections_url', window.location.pathname);

      var self = this;
      fetch(this.cartAddUrl(), {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (spinner) spinner.hidden = true;
          btn.classList.remove('is-loading');
          if (res && res.status) { // Fehler (z. B. ausverkauft)
            btn.disabled = true;
            var lbl = btn.querySelector('.fbt-popup__add-label');
            if (lbl) lbl.textContent = 'Nicht verfügbar';
            return;
          }
          self.applySections(res.sections);
          // Button in "Im Warenkorb"-Zustand versetzen (grün)
          btn.classList.add('is-incart');
          var lbl2 = btn.querySelector('.fbt-popup__add-label');
          if (lbl2) lbl2.textContent = 'Im Warenkorb';
          document.dispatchEvent(new CustomEvent('fbt:item-added', { detail: res }));
        })
        .catch(function (e) {
          if (spinner) spinner.hidden = true;
          btn.classList.remove('is-loading');
          console.error('[fbt] add failed', e);
        });
    },

    // Handle des hinzugefügten Produkts ermitteln
    // Bevorzugt der beim Submit erfasste Handle (Response enthält ihn nicht zwingend)
    productHandle: function (state) {
      if (this.pendingHandle) {
        var h = this.pendingHandle;
        this.pendingHandle = null;
        return h;
      }
      if (!state) return null;
      if (state.handle) return state.handle;
      if (state.url) {
        var m = state.url.split('?')[0].match(/\/products\/([^\/]+)/);
        if (m) return m[1];
      }
      return null;
    },

    // Section für das Produkt laden und ggf. Popup zeigen
    // "max. einmal pro Tag" – Zeitstempel im localStorage (rollendes 24h-Fenster)
    shownKey: 'fbt_shown_v2',
    oncePerDayMs: 24 * 60 * 60 * 1000,
    wasShownToday: function () {
      try {
        var raw = window.localStorage.getItem(this.shownKey);
        if (!raw) return false;
        var ts = parseInt(raw, 10);
        if (!ts) return false;
        return (Date.now() - ts) < this.oncePerDayMs;
      } catch (e) { return false; }
    },
    markShownNow: function () {
      try {
        window.localStorage.setItem(this.shownKey, String(Date.now()));
      } catch (e) {}
    },

    maybeShow: function (state, openDrawer) {
      var cfg = window.FBT_CONFIG || {};
      if (cfg.enabled === false) { this.pendingHandle = null; this.pendingVariant = null; openDrawer(); return; }

      var handle = this.productHandle(state);
      if (!handle) { openDrawer(); return; }

      // Max. einmal pro Tag, gesamt (per Theme-Setting)
      if (cfg.oncePerDay && this.wasShownToday()) { this.pendingVariant = null; openDrawer(); return; }

      var variant = this.pendingVariant;
      this.pendingVariant = null;
      var url = '/products/' + handle + '?section_id=' + SECTION;
      if (variant) url += '&variant=' + encodeURIComponent(variant);

      var self = this;
      fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var data = doc.querySelector('.fbt-popup__data');
          var hasItems = data && data.getAttribute('data-fbt-has-items') === 'true' &&
            data.querySelectorAll('[data-fbt-item]').length > 0;
          if (hasItems) {
            if (cfg.oncePerDay) self.markShownNow();
            self.open(data.outerHTML, openDrawer);
          } else {
            openDrawer();
          }
        })
        .catch(function (e) {
          console.error('[fbt] section fetch failed', e);
          openDrawer();
        });
    }
  };

  window.FBTPopup = FBT;

  // Handle beim Add-to-Cart merken. Das Theme nutzt einen eigenen Click-Handler
  // (kein natives form submit), daher hängen wir uns in der Capture-Phase an den
  // Klick auf den Add-Button – läuft vor dem fetch /cart/add.
  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      // eigene Popup-Buttons ignorieren
      if (e.target.closest('[data-fbt-add]')) return;
      var btn = e.target.closest(
        '[name="add"], button[type="submit"], .product-form__submit, [data-add-to-cart], add-to-cart, .cart-crosssell__add'
      );
      if (!btn) return;
      var inAddForm = btn.closest('form[action*="/cart/add"]') || btn.closest('product-form');
      var inDrawer = btn.closest('cart-drawer') || btn.closest('mini-cart');
      // nur echte Add-to-Cart-Trigger (Produkt-Formular oder ein Element im Warenkorb)
      if (!inAddForm && !inDrawer) return;
      // Add aus dem Warenkorb (Cross-Sell im Drawer) -> kein Popup
      FBT.suppressNext = !!inDrawer;
      if (!inDrawer) {
        var handle = FBT.resolveHandleFromForm(btn);
        if (handle) {
          FBT.pendingHandle = handle;
          var vinput = (btn.closest('form') || document).querySelector('[name="id"], [name=id]');
          FBT.pendingVariant = vinput ? vinput.value : null;
        }
      }
    },
    true
  );

  // Fallback: auch natives form submit abdecken
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
        var h = FBT.resolveHandleFromForm(form);
        if (h) FBT.pendingHandle = h;
      }
    },
    true
  );

  // MiniCart.renderContents patchen, sobald das Custom-Element definiert ist
  function patchMiniCart() {
    var MiniCart = window.customElements && customElements.get('mini-cart');
    if (!MiniCart || MiniCart.prototype.__fbtPatched) return false;

    var original = MiniCart.prototype.renderContents;

    MiniCart.prototype.renderContents = function (parsedState) {
      var self = this;
      // Cart-Sektionen aktualisieren, aber Drawer NICHT sofort öffnen
      try {
        this.productId = parsedState && parsedState.id;
        this.getSectionsToRender().forEach(function (section) {
          var el = document.getElementById(section.id);
          if (el && parsedState && parsedState.sections && parsedState.sections[section.id]) {
            el.innerHTML = self.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          }
        });
      } catch (e) {
        // Fallback: Originalverhalten
        return original.call(this, parsedState);
      }

      var openDrawer = function () { self.open(); };

      // Kein Popup, wenn aus dem Warenkorb (Cross-Sell im Drawer) hinzugefügt wird,
      // oder wenn das Popup global deaktiviert ist.
      var cfg = window.FBT_CONFIG || {};
      var suppress = FBT.suppressNext;
      FBT.suppressNext = false;
      if (cfg.enabled === false || suppress) {
        FBT.pendingHandle = null;
        FBT.pendingVariant = null;
        openDrawer();
        return;
      }

      FBT.maybeShow(parsedState, openDrawer);
    };

    MiniCart.prototype.__fbtPatched = true;
    return true;
  }

  if (!patchMiniCart()) {
    // cart-drawer.js wird ggf. später per defer ausgeführt -> kurz pollen
    var tries = 0;
    var iv = setInterval(function () {
      if (patchMiniCart() || ++tries > 50) clearInterval(iv);
    }, 100);
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('mini-cart').then(patchMiniCart);
    }
  }
})();
